import { PartyModal } from '../../party/modal/party-modal';
import { SoDetailModal } from './so-detail-modal';
import { PurchaseOrderModal } from '../../purchase-order/modal/purchase-order';
import { GenricDataModel } from '../../report/modal/genric-data-model';
import { UserModal } from '../../user/modal/user-modal';
import { OrgProfileModal } from '../../org-profile/modal/org-profile-modal';
import { BranchModel } from '../../branch/model/branch-model';
import { LocationMasterModel } from '../../location/model/location-master-model';
import { MaterialPropertiesModal } from '../../material-properties/modal/material-properties-modal';
import { PartyDetailModal } from '../../party/modal/party-detail-modal';
import { StatusModel } from '../../pre-inward/modal/status-model';
import { FreightModal } from '../../freight/modal/freight-modal';

export class SalesOrderModal {
  id: number;
  soNumber: string;
  party: PartyModal;
  remark: string;
  name: string;
  date: Date;
  freight: any = 0;
  grandTotal: number = 0;
  stateCode: string;
  freightValue: FreightModal;
  salesOrderItemDetails: Array<SoDetailModal>;
  salesOrderDetails: Array<SoDetailModal>;
  quotation: number;
  paymentTerms: string;
  vendorCode : string;
  quotationNo: string;
  generatedFrom: string;
  poReference: string;
  salesHead: UserModal;
  createdBy: UserModal;
  customerExpectedDate: Date;
  estimatedShippingDate: Date;
  tentativeCompletionDate: number;
  actualCompletionDate: number;
  // CBL Change #DRS
  company: OrgProfileModal;
  branch: BranchModel;
  location: LocationMasterModel;
  contactDetail: Array<PartyDetailModal>;
  shippingAddress: string;
  transporter: number;
  // For Angular Use
  generatedFromLable: string;
  dateString: string;
  partyString: string;
  moduleName: string;
  tentativeCompletionDateFormat: Date;
  actualCompletionDateFormat: Date;
  status: StatusModel;
  statusString: string;
  soStatusString: string;
  approvalStatus: StatusModel;
  poDate: Date;
}

export class commonItemProperties {
  id: number;
  itemProperty: MaterialPropertiesModal;
  name: string;
  abbreviation: string;
  time: string;
}

export class LastSOPrice {
  date: Date;
  soNumner: string;
  price: number;
}
